module.exports = __webpack_public_path__ + "static/media/git2.347fa432.png";